import type { Items } from '@ps-smart-cp/ppfw-client';
import { isSameAsSuggestion } from './suggestionComparator';

function deriveEffective<T>(values: T, suggestions: Partial<T>, touched: ReadonlySet<keyof T>): T {
  const result = { ...values };
  for (const key of Object.keys(suggestions) as (keyof T)[]) {
    if (isSuggestedKey(suggestions, touched, key)) {
      result[key] = suggestions[key] as T[keyof T];
    }
  }
  return result;
}

function isSuggestedKey<T>(suggestions: Partial<T>, touched: ReadonlySet<keyof T>, key: keyof T): boolean {
  return !touched.has(key) && suggestions[key] != null;
}

function updateValuesWithTouchTracking<T>(params: {
  initial: T;
  effective: T;
  next: T;
  suggestions: Partial<T>;
  touched: ReadonlySet<keyof T>;
  items: Items<T>;
}): { values: T; touched: Set<keyof T> } {
  const { initial, effective, next, suggestions, touched, items } = params;
  const nextTouched = new Set(touched);
  for (const key of Object.keys(next as object) as (keyof T)[]) {
    if (Object.is(next[key], effective[key])) {
      continue;
    }
    if (!isSameAsSuggestion(items[key]?.attribute, next[key], suggestions[key])) {
      nextTouched.add(key);
    }
  }
  // NOTE: 未touchedのキーはinitial値を保つため、毎回initialから再構築する。
  const values = { ...initial };
  for (const key of nextTouched) {
    values[key] = next[key];
  }
  return { values, touched: nextTouched };
}

export { deriveEffective, isSuggestedKey, updateValuesWithTouchTracking };
